import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Icon } from "ui/Icon"
import PropTypes from "prop-types"
import { Title } from "ui/Typography"
import styles from "./PageName.module.css"
import { resetBookingSelections } from "store/experiences"

export const PageName = ({ title, backPath, type }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleOnClick = () => {
    navigate(backPath || -1)
    if (type) {
      dispatch(resetBookingSelections())
    }
  }
  return (
    <div className={styles.pageName}>
      <div onClick={handleOnClick} className={styles.iconWrapper}>
        <Icon width={16} height={16} type="feather" name="ChevronLeft" color="currentColor" />
      </div>
      <Title className="mb-0" level={3}>
        {title}
      </Title>
    </div>
  )
}

PageName.propTypes = {
  title: PropTypes.string.isRequired,
  backPath: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  type: PropTypes.string
}
